import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
	state: {
		userInfo: {},
		isLogged: false
	},
	actions,
	mutations,
	getters
};
